module.exports = __webpack_public_path__ + "static/media/register.2ddb7bbc.png";